import {Injectable} from '@angular/core';
import {ApiNewsGetRequest, ApiNewsGetRequestParams, ApiNewsGetResponse} from '@api/news';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {Store} from "@ngrx/store";
import {AppState} from "@store/state/app.state";
import {ChangeTimezone} from "@iw-shop/core/functions/date";

@Injectable({
    providedIn: 'root'
})
export class NewsService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService, private store: Store<AppState>) {
    }

    get(params: ApiNewsGetRequestParams): Observable<ApiNewsGetResponse> {
        const date = ChangeTimezone(new Date(), 'Europe/Berlin');
        const body: ApiNewsGetRequest = {
            id: 'getNews',
            command: 'news/get',
            params: {
                ...{
                    filterDates: [
                        {
                            fields: ['onlineFrom'],
                            lessThanEqual: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00'
                        },
                        {
                            fields: ['onlineTo'],
                            greaterThanEqual: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59'
                        }

                    ]
                }, ...params
            }
        };
        return this.http.post<ApiNewsGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }
}
